export default "__VITE_ASSET__WUkHoAKs__"